import gql from 'graphql-tag';

export const createOpAlertLogEntry = gql`
  mutation createOpAlertLogEntry($input: OpAlertLogEntryInput) {
    createOpAlertLogEntry(input: $input) {
      id
      opAlertLogId
      time
      user
      entry
      createdBy
      createdAt
      updatedAt
      version
    }
  }
`;
